import {Component, computed, inject, input} from '@angular/core';
import {MarkdownService} from '../../../services/markdown.service';

@Component({
  selector: 'app-markdown',
  imports: [],
  template: '',
  host: {
    class: 'bordered rounded padded scrollable stretched',
    '[innerHTML]': 'html()'
  }
})
export class MarkdownComponent {
  private readonly markdown = inject(MarkdownService)
  readonly content = input.required<string, string | null | undefined>({ transform: val => val || '' })
  protected readonly html = computed(() => {
    return this.markdown.html(this.content())
  })
}
